/**
 * 管理态指令在访客态空注册
 * ssr不执行自定义指令
 * 客户端激活时无管理态指令会报错
 */

export default ['drag-resize', 'hoverTool', 'right-click'];
